import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiMenu } from "react-icons/hi";
import { RiCloseFill } from "react-icons/ri";
import "./mobilenav.scss";
import { authLink, midLinks } from "./constants";

const EventNavbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`w-full shadow-md top-0 left-0 right-0 bottom-0 fixed h-24 z-20 bg-sbg-white ${
        open && "-mb-nav-open"
      }`}
    >
      <nav className="items-center py-6 justify-between global-container flex mobiles:justify-between medium:hidden mobiles:flex">
        <Link to="/" className="flex items-center">
          <img
            src={require("../../assets/gift-logo-sd.svg").default}
            alt="logo"
          />
          <h1 className="ml-2 font-bold text-2xl">Sabigift</h1>
        </Link>

        <div className="medium:hidden flex justify-between w-2/6 min-w-min">
          {midLinks.map(({ name, link }) => {
            return <Link to={link}>{name}</Link>;
          })}
        </div>

        <div className="flex medium:hidden">
          {authLink.map(({ name, link }) => {
            return (
              <Link
                to={link}
                className={`py-2.5 px-11 rounded-lg text-base ${
                  name === "Log In"
                    ? "border border-sbg-light-green text-lgreen"
                    : "bg-sbg-light-green text-transparent ml-3  text-white"
                }`}
              >
                {name}
              </Link>
            );
          })}
        </div>

        <div className="mobiles:block hidden">
          {!open ? (
            <HiMenu
              style={{ fontSize: 26 }}
              onClick={() => {
                setOpen(true);
              }}
            />
          ) : (
            <RiCloseFill
              style={{ fontSize: 26 }}
              onClick={() => {
                setOpen(false);
              }}
            />
          )}
        </div>
      </nav>

      <div className={` mobile-nav-li my-4 ${open ? "block" : "hidden"}`}>
        {midLinks.map(({ name, link }) => {
          return (
            <li className="py-3 px-6">
              <Link
                onClick={() => {
                  setOpen(false);
                }}
                to={link}
              >
                {name}
              </Link>
            </li>
          );
        })}

        {authLink.map(({ name, link }) => {
          return (
            <li className="py-3 px-6">
              <Link
                to={link}
                className={`py-2.5 px-11 rounded-lg text-base ${
                  name === "Log In"
                    ? "border border-sbg-light-green text-lgreen"
                    : "bg-sbg-light-green text-transparent  text-white"
                }`}
              >
                {name}
              </Link>
            </li>
          );
        })}
      </div>
    </div>
  );
};

export default EventNavbar;
